import { useState } from "react";
import { toast } from "sonner";
import { Check } from "lucide-react";
import { appsApi, errMsg, notifyError } from "@/lib/appsApi";

export const TabChips = ({ tabs, selected, onToggle, disabled, testid }) => (
  <div className="flex flex-wrap gap-1.5" data-testid={testid}>
    {tabs.map((t) => {
      const on = selected.includes(t.id);
      return (
        <button key={t.id} type="button" onClick={() => onToggle(t.id)} disabled={disabled} aria-pressed={on}
          className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-1 text-[11px] font-medium transition-colors disabled:opacity-60 ${on ? "border-sky-600 bg-sky-600 text-white" : "border-slate-200 bg-white text-slate-600 hover:border-sky-400"}`}
          data-testid={`${testid}-${t.id}`}>
          {on && <Check className="h-3 w-3" />}{t.name}
        </button>
      );
    })}
  </div>
);

export const TesterTabs = ({ u, tabs, onChange }) => {
  const [busy, setBusy] = useState(false);
  if (u.role === "admin") return <p className="mt-2 text-[11px] text-slate-500">Admins see every tab.</p>;
  const selected = Array.isArray(u.tabs) ? u.tabs : [];
  const toggle = async (id) => {
    const next = selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id];
    setBusy(true);
    try {
      const r = await appsApi.put(`/admin/users/${u.user_id}/tabs`, { tabs: next });
      onChange({ ...u, ...(r?.data ?? {}) });
      const name = tabs.find((t) => t.id === id)?.name;
      toast.success(`${u.email} ${next.includes(id) ? "can now see" : "no longer sees"} ${name}`);
    } catch (err) {
      notifyError(errMsg(err, `Changing tabs for ${u.email}`));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mt-2">
      <TabChips tabs={tabs} selected={selected} onToggle={toggle} disabled={busy} testid={`apps-tester-tabs-${u.user_id}`} />
      {selected.length === 0 && <p className="mt-1 text-[11px] font-medium text-amber-700" data-testid={`apps-tester-no-tabs-${u.user_id}`}>No tabs enabled, so this tester can't see any files.</p>}
    </div>
  );
};
